import React from 'react';
import { Field as ReduxField } from 'redux-form';
import PropTypes from 'prop-types';
import Component from 'BaseComponent';

function isString(s) {
  return typeof s === 'string';
}

class Field extends Component {

  static propTypes = {
    input: PropTypes.object.isRequired,
    children: PropTypes.element.isRequired,
    meta: PropTypes.object.isRequired,
    showErrorsIfUntouched: PropTypes.bool.isRequired,
    inline: PropTypes.bool.isRequired,
    className: PropTypes.string,
    label: PropTypes.string,
    hint: PropTypes.string,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    wrapInput: PropTypes.func,
    showLabel: PropTypes.bool,
  };

  static defaultProps = {
    className: '',
    label: '',
    hint: '',
    placeholder: '',
    showErrorsIfUntouched: false,
    showLabel: true,
    inline: false,
    required: false,
    wrapInput: input => input,
  };

  renderHint() {
    const { hint: hintKey } = this.props;

    if (!hintKey) {
      return undefined;
    }

    const hint = this.t(hintKey);

    return (
      <div className="form__hint">
        {hint && <p>{hint}</p>}
      </div>
    );
  }

  render() {
    const {
      inline,
      showLabel,
      children,
      required,
      showErrorsIfUntouched,
      input,
      wrapInput,
      meta: { touched, error },
      label: labelKey,
      placeholder: placeholderKey,
    } = this.props;

    const label = labelKey && this.t(labelKey);
    const placeholder = (isString(placeholderKey) || isString(labelKey)) &&
      this.t(isString(placeholderKey) ? placeholderKey : labelKey);
    const hasErrors = (showErrorsIfUntouched || touched) && error;

    const className = ['form__field'];
    className.push(this.props.className);

    if (inline) {
      className.push('form__field--inline');
    }
    if (hasErrors) {
      className.push('form__field--invalid');
    }

    const value = typeof children.type === 'string' ?
      input.value :
      // if the input is a component, avoid coalescing empty values with
      // an empty string
      (input.value || null);

    return (
      <div className={className.join(' ')}>
        {
          showLabel &&
            <label htmlFor={input.name} className="form__label">
              {label}{required && '*'}
            </label>
        }
        {
          React.cloneElement(
            children,
            Object.assign(
              wrapInput(input),
              { placeholder, id: input.name, value },
            ),
          )
        }
        {
          hasErrors ?
            <div className="form__error">
              {this.t(error.error, error.meta)}
            </div> :
            this.renderHint()
        }
      </div>
    );
  }
}

export default function OuterField(props) {
  return (
    <ReduxField {...props} component={Field}>
      {props.children}
    </ReduxField>
  );
}

OuterField.propTypes = {
  children: PropTypes.element.isRequired,
};



// WEBPACK FOOTER //
// ./app/form/Field.jsx